module.exports = __webpack_public_path__ + "img/notif_blue.6998e4d3.svg";